
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexg4zyBmy53_45A734omKA4Z3h3STyyRh9YIotIEMHMwgckMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/index.vue?macro=true";
import { default as login_Go5n9IaKWbnIB47Ji7tpuNyszC_45VgTBIZsIWVVEYFAMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/login.vue?macro=true";
import { default as clublabbNr7Ue0ToPtJlH_4542LuzLh6mu11Y1Kz6DmVhZ4g_45sz4Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/clublab.vue?macro=true";
import { default as RecoverDAHTyMCzuwmcqG2N6mK2JtWUqrqQluMIA8RnHKHdcXAMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/Recover.vue?macro=true";
import { default as dashboardqX7vocID_45XiFwNFKJD_uH216rPWk7eiYNeNB2GIuVtUMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/dashboard.vue?macro=true";
import { default as lastQOOFmimmf6d6w6Ag3OAjMjE_45EV_45_4558A76yPNGrdSlm8Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/post/last.vue?macro=true";
import { default as indexvCRsoBIHoCcNCDTzyfzg3HC_4pIZKQf7V1XmqiJ23EEMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/blog/index.vue?macro=true";
import { default as _91id_93IGTgcQp3e2mu4igkRtdm5lGCyOS71uaOyH8wYqUMGI8Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/diario/[id].vue?macro=true";
import { default as _91slug_93_45ZnInIAXf_kaiwmu2KfCxFCzZQ_459UXflQG2f2gZ3s_45AMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/post/[slug].vue?macro=true";
import { default as perfilJSKQ0PvJYwVW7hZZlH_e8AB1BV2u2IO1zFKo51ntNu8Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/user/perfil.vue?macro=true";
import { default as _91id_939RhU8brQ30NeSy76kuPspPt8tN4wIfPHB3kSWfrbP1sMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/agendar/[id].vue?macro=true";
import { default as criar0xCOjiQYsWP_xzADd12X95uKkaj3B3UakMw7zA7kb50Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/diario/criar.vue?macro=true";
import { default as index2C7_IVjudsHQZJqKmtWCi6NNRHLyrWzCObVLmDwFWMsMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/diario/index.vue?macro=true";
import { default as of_usejGqVkoueh5XvE_45F8y_0WWicF_45B86MQY5wMViyDZoFW8Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/terms/of_use.vue?macro=true";
import { default as index3OsOyhmWX3hiOjOKjSOv1r90fbj4HnD5vX5jfpwMLa0Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/agendar/index.vue?macro=true";
import { default as registervS20nH_45waxAoJWa_9M1WVU9_XdFJi0p0_HeDYu4XNkAMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/auth/register.vue?macro=true";
import { default as cadastroJpwk8JHxDKNZ6b6PPK_WIJOYnMpAK38NaKKcsFc2744Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/user/cadastro.vue?macro=true";
import { default as indexdg7Kqd3zCiMx3MkHP7Rxq0TV3gMv_45u_7_45g_45UxgYDQM8Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/feedback/index.vue?macro=true";
import { default as listX8UASYjTDhltcGG3qgMdGxrEoPHNS7MLpXo_OcY4Ft4Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/pagamento/list.vue?macro=true";
import { default as index1jRPAuxELpyIm7mSZyKcmnODC7F3JAxLUOKxhX6qZboMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/postback/index.vue?macro=true";
import { default as _91id_93FCShwhmfrX4oBKWFo6f4idz2jcYbfGq5SwnPos19y2AMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/psicologa/[id].vue?macro=true";
import { default as indexbmNhU_45tj75CQ6jwzbTyD123WjhphOM7fKfP0E9uyatUMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/psicologa/index.vue?macro=true";
import { default as indexNeFjQm5Lb_45xtiY1TM24sq_45lmAAuO0TAQD1xeXHIrx8MMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/sobre-mim/index.vue?macro=true";
import { default as indexewGBCj0KOYjIIO3kejyDlc66mpjOaa0CMXU_45jCkHM34Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/psicologas/index.vue?macro=true";
import { default as indexMjxnQAQc_iNuvtPQqX4xvEN3p7LmmkcC86wNsqNaynoMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/agendamento/index.vue?macro=true";
import { default as confirmarddBAGL1RrmkzGaiDc9sirk7jNQH2pwL9KJmdiaZeB2kMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/agendar/confirmar.vue?macro=true";
import { default as contrato_45terapeuticoGvvSsnAA3lelvAmeFnDyq_45UGilEbKOc_wMHX4oHx62kMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/contrato-terapeutico.vue?macro=true";
import { default as index6dNE_Pb0eFE0adQr7a19gv1ghseT98F95myUpx8fs9wMeta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/nossa-abordagem/index.vue?macro=true";
import { default as _91id_93cTlrisaj1JS77mM5m3VmOI9UjGfYjsE8_J0F2TvPB18Meta } from "/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/pagamento/sessao/[id].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexg4zyBmy53_45A734omKA4Z3h3STyyRh9YIotIEMHMwgckMeta || {},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: { ...(login_Go5n9IaKWbnIB47Ji7tpuNyszC_45VgTBIZsIWVVEYFAMeta || {}), ...{"middleware":"is-logged-in"} },
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/login.vue")
  },
  {
    name: "clublab",
    path: "/clublab",
    meta: clublabbNr7Ue0ToPtJlH_4542LuzLh6mu11Y1Kz6DmVhZ4g_45sz4Meta || {},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/clublab.vue")
  },
  {
    name: "Recover",
    path: "/Recover",
    meta: { ...(RecoverDAHTyMCzuwmcqG2N6mK2JtWUqrqQluMIA8RnHKHdcXAMeta || {}), ...{"middleware":"is-logged-in"} },
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/Recover.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: {"middleware":["is-logged-out","check-contract"]},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/dashboard.vue")
  },
  {
    name: "post-last",
    path: "/post/last",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/post/last.vue")
  },
  {
    name: "blog",
    path: "/blog",
    meta: indexvCRsoBIHoCcNCDTzyfzg3HC_4pIZKQf7V1XmqiJ23EEMeta || {},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/blog/index.vue")
  },
  {
    name: "diario-id",
    path: "/diario/:id()",
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/diario/[id].vue")
  },
  {
    name: "post-slug",
    path: "/post/:slug()",
    meta: _91slug_93_45ZnInIAXf_kaiwmu2KfCxFCzZQ_459UXflQG2f2gZ3s_45AMeta || {},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/post/[slug].vue")
  },
  {
    name: "user-perfil",
    path: "/user/perfil",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/user/perfil.vue")
  },
  {
    name: "agendar-id",
    path: "/agendar/:id()",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/agendar/[id].vue")
  },
  {
    name: "diario-criar",
    path: "/diario/criar",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/diario/criar.vue")
  },
  {
    name: "diario",
    path: "/diario",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/diario/index.vue")
  },
  {
    name: "terms-of_use",
    path: "/terms/of_use",
    meta: of_usejGqVkoueh5XvE_45F8y_0WWicF_45B86MQY5wMViyDZoFW8Meta || {},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/terms/of_use.vue")
  },
  {
    name: "agendar",
    path: "/agendar",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/agendar/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    meta: { ...(registervS20nH_45waxAoJWa_9M1WVU9_XdFJi0p0_HeDYu4XNkAMeta || {}), ...{"middleware":"is-logged-in"} },
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/auth/register.vue")
  },
  {
    name: "user-cadastro",
    path: "/user/cadastro",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/user/cadastro.vue")
  },
  {
    name: "feedback",
    path: "/feedback",
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/feedback/index.vue")
  },
  {
    name: "pagamento-list",
    path: "/pagamento/list",
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/pagamento/list.vue")
  },
  {
    name: "postback",
    path: "/postback",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/postback/index.vue")
  },
  {
    name: "psicologa-id",
    path: "/psicologa/:id()",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/psicologa/[id].vue")
  },
  {
    name: "psicologa",
    path: "/psicologa",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/psicologa/index.vue")
  },
  {
    name: "sobre-mim",
    path: "/sobre-mim",
    meta: indexNeFjQm5Lb_45xtiY1TM24sq_45lmAAuO0TAQD1xeXHIrx8MMeta || {},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/sobre-mim/index.vue")
  },
  {
    name: "psicologas",
    path: "/psicologas",
    meta: indexewGBCj0KOYjIIO3kejyDlc66mpjOaa0CMXU_45jCkHM34Meta || {},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/psicologas/index.vue")
  },
  {
    name: "agendamento",
    path: "/agendamento",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/agendamento/index.vue")
  },
  {
    name: "agendar-confirmar",
    path: "/agendar/confirmar",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/agendar/confirmar.vue")
  },
  {
    name: "contrato-terapeutico",
    path: "/contrato-terapeutico",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/contrato-terapeutico.vue")
  },
  {
    name: "nossa-abordagem",
    path: "/nossa-abordagem",
    meta: index6dNE_Pb0eFE0adQr7a19gv1ghseT98F95myUpx8fs9wMeta || {},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/nossa-abordagem/index.vue")
  },
  {
    name: "pagamento-sessao-id",
    path: "/pagamento/sessao/:id()",
    meta: {"middleware":"is-logged-out"},
    component: () => import("/home/laboratoriodoser/htdocs/laboratoriodoser.com.br/pages/pagamento/sessao/[id].vue")
  }
]